/* OTP — Apoio humano.
   The request itself goes through Shopify's own contact form, so it lands in the
   store inbox like any other message. Shopify's form carries text only, so the
   photo is handed to WhatsApp on the confirmation step. */

class OtpHelp extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = 'true';

    this.modal = this.querySelector('[data-modal]');
    this.form = this.querySelector('[data-form]');
    if (!this.modal || !this.form) return;

    this.formPane = this.querySelector('[data-pane-form]');
    this.donePane = this.querySelector('[data-pane-done]');
    this.fileInput = this.querySelector('[data-file]');
    this.thumb = this.querySelector('[data-thumb]');
    this.filename = this.querySelector('[data-filename]');
    this.error = this.querySelector('[data-error]');
    this.submit = this.querySelector('[data-submit]');
    this.waLink = this.querySelector('[data-wa]');
    this.emptyLabel = this.filename ? this.filename.textContent : '';

    this.querySelectorAll('[data-open]').forEach((b) =>
      b.addEventListener('click', () => this.open())
    );
    this.querySelectorAll('[data-close]').forEach((b) =>
      b.addEventListener('click', () => this.modal.close())
    );

    // clicking the backdrop closes; clicking the sheet must not
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) this.modal.close();
    });
    this.modal.addEventListener('close', () => this.reset());

    if (this.fileInput) this.fileInput.addEventListener('change', () => this.showFile());
    this.form.addEventListener('submit', (e) => this.send(e));
  }

  open() {
    if (typeof this.modal.showModal === 'function') this.modal.showModal();
    else this.modal.setAttribute('open', '');
    const first = this.form.querySelector('input:not([type=hidden])');
    if (first) setTimeout(() => first.focus({ preventScroll: true }), 60);
  }

  reset() {
    this.formPane.hidden = false;
    this.donePane.hidden = true;
    this.error.textContent = '';
    this.submit.disabled = false;
    this.form.reset();
    this.clearThumb();
  }

  clearThumb() {
    if (!this.thumb) return;
    this.thumb.style.backgroundImage = '';
    this.thumb.classList.remove('otp-help__thumb--filled');
    if (this.filename) this.filename.textContent = this.emptyLabel;
  }

  showFile() {
    const file = this.fileInput.files && this.fileInput.files[0];
    if (!file) return this.clearThumb();

    if (file.size > 10 * 1024 * 1024) {
      this.error.textContent = 'A imagem é demasiado grande (máx. 10 MB).';
      this.fileInput.value = '';
      return this.clearThumb();
    }

    this.error.textContent = '';
    if (this.filename) this.filename.textContent = file.name;
    const reader = new FileReader();
    reader.onload = () => {
      this.thumb.style.backgroundImage = 'url("' + reader.result + '")';
      this.thumb.classList.add('otp-help__thumb--filled');
    };
    reader.readAsDataURL(file);
  }

  async send(event) {
    event.preventDefault();
    const name = this.form.querySelector('[name="contact[name]"]').value.trim();
    const phone = this.form.querySelector('[name="contact[phone]"]').value.trim();

    if (!name || !phone) {
      this.error.textContent = 'Preenche o nome e o número de WhatsApp.';
      return;
    }

    this.error.textContent = '';
    this.submit.disabled = true;

    const body = this.form.querySelector('[name="contact[body]"]');
    const file = this.fileInput && this.fileInput.files && this.fileInput.files[0];
    body.value =
      'Pedido de procura de artigo (secção Apoio da homepage).\n' +
      'Nome: ' + name + '\n' +
      'WhatsApp: ' + phone + '\n' +
      'Fotografia: ' + (file ? file.name + ' — o cliente envia pelo WhatsApp' : 'não anexada');

    try {
      const data = new FormData(this.form);
      data.delete('otp-help-file');
      const res = await fetch(this.form.action, {
        method: 'POST',
        body: data,
        headers: { Accept: 'text/html' },
      });
      if (!res.ok) throw new Error(res.status);
    } catch (err) {
      // the message still reaches the shop through WhatsApp, so don't dead-end
      this.error.textContent = '';
    }

    if (this.waLink) {
      const base = this.waLink.dataset.base || this.waLink.href;
      const text =
        'Olá! Sou ' + name + '. Procuro um artigo específico e envio já a fotografia.';
      this.waLink.href = base + (base.indexOf('?') === -1 ? '?' : '&') + 'text=' + encodeURIComponent(text);
    }

    this.formPane.hidden = true;
    this.donePane.hidden = false;
    this.submit.disabled = false;
  }
}

if (!customElements.get('otp-help')) customElements.define('otp-help', OtpHelp);
